<mat-card appearance="outlined">
  <mat-card-content>
    <h2>{{ 'footer.links.termsOfUse' | translate }}</h2>
    @if (translate.currentLang == 'fr') {
      <div>
        <p>Les sites <a href="http://odq.qc.ca/">www.odq.qc.ca</a>, <a
      href="http://maboucheensante.com/">maboucheensante.com</a> et <a
    href="http://portail.odq.qc.ca/home">portail.odq.qc.ca</a> (ci-après « les sites ») et tous leurs
    sous-domaines, le cas échéant, sont la propriété exclusive de l’Ordre des dentistes du Québec (ci-après « l’ODQ
    »).<br>
    <br>
      Certains de ces sites sont accessibles par tous et d’autres ne le sont que par les membres de l’ODQ et leurs
      représentants dûment autorisés. En y naviguant, les utilisateurs acceptent de se conformer aux présentes
      conditions. L’ODQ peut modifier les renseignements qui se trouvent sur ses sites ou mettre à jour leur contenu,
      en tout ou en partie.<br>
      <br>
      </p>
      <h4>Limitation de responsabilité</h4>
      <p>Le contenu des sites ainsi que le contenu accessible au moyen des hyperliens qu’ils contiennent sont publiés
        dans un but d’information et d’éducation. Il ne s’agit en aucun cas de conseils d’expert en matière de santé
        buccodentaire. Les renseignements, textes, avis et opinions publiés ou rendus disponibles sur les sites ou par
        hyperliens sont offerts tels quels en date de leur mise en ligne et ils n’engagent que la responsabilité de
        leurs auteurs. La présence de ces hyperliens sur les sites ne signifie pas que l’ODQ en endosse le contenu ni
        celui des autres sites qui pourraient y être liés.<br>
        <br>
          Bien que l’ODQ autorise les hyperliens vers ces sites, il n’est aucunement responsable de toute violation, par
          le site tiers, à une loi, à un règlement, à un code d’éthique ou à une norme morale. L’ODQ se donne le droit
          d’interdire ou de refuser d’accepter un hyperlien vers ses sites. Le cas échéant, l’utilisateur qui a affiché
          l’hyperlien doit le retirer à la demande de l’ODQ.<br>
          <br>
            L’ODQ ne garantit pas un accès sans interruption à ses sites. Par conséquent, il ne peut être tenu responsable
            d’un quelconque dommage résultant directement ou indirectement de l’utilisation ou de la performance des sites,
            de leur contenu ou de leurs fonctionnalités.<br>
            <br>
              L’ODQ ne peut garantir l’exactitude, la validité ou l’exhaustivité des renseignements fournis ou des hyperliens
              offerts sur ses sites. Toute erreur constatée doit être signalée à l’administrateur des sites de l’ODQ (<a
            href="mailto:support@odq.qc.ca?subject=Engagement de confidentialité">support&#64;odq.qc.ca</a>).<br>
            <br>
              Enfin, l’ODQ ne peut être tenu responsable de la véracité du contenu des publicités apparaissant sur les sites.
              Consultez à ce sujet la <a
              href="http://www.odq.qc.ca/Portals/5/fichiers_publication/journal/JODQ2018/Trousse-Media-2018-FR.pdf"
            target="_blank">politique publicitaire du Journal de l’Ordre des dentistes du Québec</a>.<br>
            <br>
            </p>
            <h4>Propriété intellectuelle</h4>
            <p>La forme et le contenu des sites sont protégés par les lois québécoises, canadiennes et étrangères relatives à
              la propriété intellectuelle, y compris les droits d’auteur, sauf indication contraire. L’ODQ détient la
              propriété exclusive de son logo.<br>
              <br>
                À moins d’une autorisation de l’ODQ ou, le cas échéant, du titulaire des droits d’auteur, il est interdit de
                reproduire, pour quelque motif et par quelque moyen que ce soit, le logo de l’ODQ ainsi que les textes,
                renseignements, avis, images et vidéos mis en ligne sur ses sites. Il est également interdit de vendre ou de
                modifier, à des fins privées, publiques ou commerciales, lesdits textes, renseignements, avis, vidéos et
                images.<br>
                <br>
                  L’ODQ s’engage à retirer des sites tout hyperlien qui mènerait à un site dont le contenu contreviendrait à la
                  Loi sur le droit d’auteur ou à toute autre règle qui concerne la propriété intellectuelle, et ce, dès qu’il est
                  informé de la situation.<br>
                  <br>
                    L’ODQ se réserve par ailleurs le droit d’interdire l’indexation externe et le téléchargement massif des
                    informations diffusées sur ses sites. Il se réserve aussi le droit de bloquer l’accès à tout système qui remplit
                    de telles fonctions.<br>
                    <br>
                    </p>
                    <h4>Sécurité </h4>
                    <p>L’ODQ n’est pas responsable de la transmission de virus informatiques ou d’autres logiciels malveillants
                      pouvant survenir en dépit des mesures de protection mises en place. L’utilisateur assume tout risque lié à
                      l’utilisation des sites ainsi qu’au téléchargement de documents et d’images provenant des sites ou à
                      l’utilisation des hyperliens qu’ils contiennent.<br>
                      <br>
                        L’ODQ n’est pas non plus responsable des dommages à l’utilisateur ou à un tiers causés par l’envoi, par un
                        utilisateur, de renseignements confidentiels au moyen des liens courriel publiés sur les sites. Rappelons
                        qu’Internet ne constitue pas un réseau de communication sécuritaire.<br>
                        <br>
                          Les fonctionnalités Google Analytics sont utilisées par l’ODQ pour recueillir des données démographiques liées
                          aux intérêts des utilisateurs des sites.
                          <br>
                            Afin d’assurer les fonctionnalités de son système, les sessions, navigations, consultations, sélections de menu
                            et toutes informations consultées ou données saisies sur le site <a
                          href="https://portail.odq.qc.ca/">portail.odq.qc.ca</a> peuvent être sauvegardées. Les informations ainsi
                          conservées sont utilisées à des fins de contrôle de qualité et de soutien aux utilisateurs, et sont protégées
                          par les règles de confidentialité en vigueur à l’ODQ.
                        </p>
                        <p></p>
                        <h4>Lois applicable</h4>
                        <p>
                          Cette entente est régie par les lois québécoises. Tout litige découlant de son interprétation et de son
                          application sera jugé par le tribunal du district judiciaire du siège social de l’ODQ, qui est situé à Montréal.
                        </p>
                      </div>
                    }
                    @if (translate.currentLang == 'en') {
                      <div>
                        <p>
                          The sites <a href="http://odq.qc.ca/">www.odq.qc.ca</a>, <a
                        href="http://maboucheensante.com/">maboucheensante.com</a> and <a
                      href="http://portail.odq.qc.ca/home">portail.odq.qc.ca</a> (hereinafter "the sites") and all their
                      subdomains, if any, are the exclusive property of the ODQ.
                      <br><br>
                      Some of these sites are accessible to all and others are accessible only to ODQ members and their duly
                      authorized representatives. By browsing these sites, users agree to abide by the current terms and conditions.
                      The ODQ may modify the information found on its sites or update their content, in whole or in part.
                    </p>
                    <h4> Limitation of Liability</h4>
                    <p>
                      The content of the sites as well as the content accessible by means of the hyperlinks they contain is published
                      for information and educational purposes. It is not intended to provide expert advice on oral health matters.
                      The information, texts, opinions and views published or made available on the sites or by hyperlinks are offered
                      as is on the date they were posted online and are the sole responsibility of their authors. The presence of
                      these hyperlinks on the sites does not mean that the ODQ endorses their content or that of other sites that may
                      be linked to them.
                      <br><br>
                      Although the ODQ authorizes hyperlinks to these sites, it is in no way responsible for any violation by the
                      third party site of any law, regulation, code of ethics or moral standard. The ODQ reserves the right to
                      prohibit or refuse to accept a hyperlink on its sites. In such a case, the user who posted the hyperlink must
                      remove it at the request of the ODQ.
                      <br><br>
                      The ODQ does not guarantee uninterrupted access to its sites. Consequently, it cannot be held liable for any
                      damage resulting directly or indirectly from the use or performance of the sites, their content or
                      functionality.
                      <br><br>
                      The ODQ cannot guarantee the accuracy, validity or completeness of the information provided or the hyperlinks
                      offered on its sites. Any errors found should be reported to the ODQ's Webmaster by writing to <a
                    href="mailto:support@odq.qc.ca?subject=Engagement de confidentialité">support&#64;odq.qc.ca</a>.
                    <br><br>
                    Finally, the ODQ cannot be held responsible for the truthfulness of the content of the advertisements appearing
                    on the sites. In this regard, consult the <a
                    href="http://www.odq.qc.ca/Portals/5/fichiers_publication/journal/JODQ2018/Trousse-Media-2018-FR.pdf"
                  target="_blank">advertising policy of the Journal de l'Ordre des dentistes du Québec</a>.
                </p>
                <h4>Intellectual property</h4>
                <p>
                  The form and content of the sites are protected by Quebec, Canadian and foreign laws relating to intellectual
                  property, including copyright, unless otherwise indicated. The ODQ holds exclusive ownership of its logo.
                  <br><br>
                  Unless authorized by the ODQ or, where applicable, by the copyright holder, it is forbidden to
                  reproduce, for any reason and by any means whatsoever, the ODQ logo as well as the texts, information, notices,
                  images and videos posted on its sites. It is also prohibited to sell or modify, for private, public or
                  commercial purposes, the said texts, information, notices, videos and images.
                  <br><br>
                  The ODQ undertakes to remove from its sites any hyperlink that leads to a site whose content contravenes
                  the Copyright Act or any other rule concerning intellectual property, as soon as it is informed of the
                  situation.
                  <br><br>
                  The ODQ also reserves the right to prohibit the external indexing and mass downloading of information
                  published on its sites. It also reserves the right to block access to any system that performs such functions.
                </p>
                <h4>Security </h4>
                <p>
                  The ODQ is not responsible for the transmission of computer viruses or other malicious software that may occur
                  despite the protective measures in place. The user assumes all risks associated with the use of the sites and
                  the downloading of documents and images from the sites or the use of hyperlinks contained therein.
                  <br><br>
                  The ODQ is also not liable for any damage to the user or a third party caused by a user sending confidential
                  information via e-mail links published on the sites. Please note that the Internet is not a secure communication
                  network.
                  <br><br>
                  Google Analytics is used by the ODQ to gather demographic information related to the interests of users of the
                  sites.
                  <br><br>
                  In order to ensure the functionality of its system, sessions, browsing, consultations, menu selections and any
                  information consulted or data entered on the portal.odq.qc.ca site may be saved. The information stored in this
                  way is used for quality control and user support purposes and is protected by the ODQ's confidentiality rules.
                </p>
                <h4>Applicable laws</h4>
                <p>
                  This agreement is governed by the laws of Quebec. Any dispute arising from its interpretation and application
                  will
                  be judged by the court of the judicial district of the ODQ's head office, which is located in Montreal.
                </p>
              </div>
            }
          </mat-card-content>
        </mat-card>